import { PageContainer } from '@components/Layout/PageContainer';
import { useCurrentProject } from '@modules/projects/utils/useCurrentProject';
import { Stack } from '@mui/material';
import { useCommercialProjectCalculatorsQuery, useTenantSettingsQuery } from 'gql/index';
import { useIntl } from 'react-intl';
import { CalculatorsTable } from '../components/CommercialConstructionCalculator/components/CalculatorsTable';

export const ProjectCalculatorsPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const { projectId } = useCurrentProject();

  const { data: tenantSettings } = useTenantSettingsQuery({}, { select: d => d.tenantSettings, staleTime: 600000 });
  const isConstructionAddonEnabled = tenantSettings?.isConstructionAddonEnabled;

  const { data: calculators, isFetching: isFetchingCalculators } = useCommercialProjectCalculatorsQuery(
    { projectId },
    { select: d => d.commercialProjectCalculators, enabled: isConstructionAddonEnabled }
  );

  if (!isConstructionAddonEnabled) {
    return null;
  }

  return (
    <PageContainer title={formatMessage({ id: 'Construction calculators' })}>
      <Stack>
        <CalculatorsTable isLoading={isFetchingCalculators} calculators={calculators ?? []} />
      </Stack>
    </PageContainer>
  );
};

